export const label = {
  'es-US': 'Seleccionar',
  'pt-BR': 'Selecionar',
  'pt-PT': 'Selecionar',
  'zh-TW': '選擇',
  ar: 'اختر',
  az: 'Seç',
  be: 'Выбраць',
  bg: 'Избери',
  bs: 'Odaberi',
  cnr: 'Odaberi',
  cs: 'Vybrat',
  da: 'Vælg',
  de: 'Auswählen',
  el: 'Επιλέξτε',
  en: 'Select',
  es: 'Seleccionar',
  et: 'Vali',
  fi: 'Valitse',
  fr: 'Sélectionner',
  he: 'בחר',
  hr: 'Odaberi',
  hu: 'Válasszon',
  hy: 'Ընտրել',
  id: 'Pilih',
  is: 'Velja',
  it: 'Seleziona',
  ja: '選択',
  ka: 'აირჩიეთ',
  ko: '선택',
  lt: 'Pasirinkti',
  lv: 'Izvēlēties',
  mk: 'Избери',
  nl: 'Selecteer',
  no: 'Velg',
  pl: 'Wybierz',
  pt: 'Selecionar',
  ro: 'Selectează',
  ru: 'Выберите',
  sk: 'Vybrať',
  sl: 'Izberi',
  sq: 'Zgjidh',
  sr: 'Izaberi',
  sv: 'Välj',
  th: 'เลือก',
  tr: 'Seç',
  uk: 'Виберіть',
  vi: 'Chọn',
  zh: '选择',
};
